var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { changeEmailAsync, deleteAccountAsync, getAccountInformationAsync, verifyEmailAsync, } from '../../account/redux/accountSlice';
import { login, signup, recoverPassword, resetPassword, } from '../services/AuthService';
const user = localStorage.getItem('user');
const parsedUser = user ? JSON.parse(user) : null;
export const authInitialState = {
    isAuthenticated: !!localStorage.getItem('user'),
    token: localStorage.getItem('token') || '',
    user: parsedUser,
    status: 'idle',
    error: null,
};
const authSlice = createSlice({
    name: 'auth',
    initialState: authInitialState,
    reducers: {
        logout(state) {
            state.token = '';
            state.isAuthenticated = false;
            state.user = null;
            localStorage.setItem('token', '');
            localStorage.setItem('user', '');
        },
    },
    extraReducers: (builder) => {
        builder
            // ----------------------
            // Log In
            // ----------------------
            .addCase(loginUser.pending, (state) => {
            state.status = 'loading';
        })
            .addCase(loginUser.fulfilled, (state, action) => {
            state.status = 'idle';
            state.isAuthenticated = true;
            state.token = action.payload.token;
            state.user = action.payload.user;
            localStorage.setItem('token', action.payload.token || '');
            localStorage.setItem('user', JSON.stringify(action.payload.user || ''));
        })
            .addCase(loginUser.rejected, (state, action) => {
            state.status = 'failed';
            state.error =
                action.error.message ||
                    'Login failed. Please check your username and password.';
        })
            // ----------------------
            // Sign Up
            // ----------------------
            .addCase(signupUserAsync.pending, (state) => {
            state.status = 'loading';
        })
            .addCase(signupUserAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            state.isAuthenticated = true;
            state.token = action.payload.token;
            state.user = action.payload.user;
            localStorage.setItem('token', action.payload.token || '');
            localStorage.setItem('user', JSON.stringify(action.payload.user || ''));
        })
            .addCase(signupUserAsync.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message || 'Signup failed';
        })
            // ----------------------
            // Recover Password
            // ----------------------
            .addCase(recoverPasswordAsync.pending, (state) => {
            state.status = 'loading';
        })
            .addCase(recoverPasswordAsync.fulfilled, (state, action) => {
            state.status = 'idle';
        })
            .addCase(recoverPasswordAsync.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message || 'Recover password failed';
        })
            // ----------------------
            // Reset Password
            // ----------------------
            .addCase(resetPasswordAsync.pending, (state) => {
            state.status = 'loading';
        })
            .addCase(resetPasswordAsync.fulfilled, (state, action) => {
            state.status = 'idle';
        })
            .addCase(resetPasswordAsync.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error.message || 'Reset password failed';
        })
            // ----------------------------------------------
            // From Account Slice: Get Account Information
            // ----------------------------------------------
            .addCase(getAccountInformationAsync.fulfilled, (state, action) => {
            state.user = action.payload;
            state.isAuthenticated = true;
        })
            .addCase(changeEmailAsync.fulfilled, (state, action) => {
            const newEmail = action.meta.arg.newEmail;
            if (state.user) {
                state.user.pendingEmail = newEmail;
                state.user.emailVerified = false;
            }
            localStorage.setItem('user', JSON.stringify(state.user));
        })
            .addCase(verifyEmailAsync.fulfilled, (state) => {
            var _a;
            if (((_a = state.user) === null || _a === void 0 ? void 0 : _a.pendingEmail) && !state.user.emailVerified) {
                state.user.email = state.user.pendingEmail;
                state.user.emailVerified = true;
                state.user.pendingEmail = null;
            }
            localStorage.setItem('user', JSON.stringify(state.user));
        })
            .addCase(deleteAccountAsync.fulfilled, (state) => {
            state.token = '';
            state.isAuthenticated = false;
            state.user = null;
            localStorage.setItem('token', '');
            localStorage.setItem('user', '');
        });
    },
});
export const loginUser = createAsyncThunk('auth/loginUser', (loginRequest, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const response = yield login(loginRequest);
        return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (error) {
        if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: 'Login failed' });
    }
}));
export const signupUserAsync = createAsyncThunk('auth/signupUser', (signupRequest, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    try {
        const response = yield signup(signupRequest);
        return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (error) {
        if ((_b = error.response) === null || _b === void 0 ? void 0 : _b.data) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: 'Signup failed' });
    }
}));
export const recoverPasswordAsync = createAsyncThunk('auth/sendPasswordResetEmail', (recoverPasswordRequest, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _c;
    try {
        return yield recoverPassword(recoverPasswordRequest);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (error) {
        return rejectWithValue((_c = error.response) === null || _c === void 0 ? void 0 : _c.data);
    }
}));
export const resetPasswordAsync = createAsyncThunk('auth/resetPassword', (resetPasswordRequest, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _d;
    try {
        const response = yield resetPassword(resetPasswordRequest);
        return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (error) {
        return rejectWithValue((_d = error.response) === null || _d === void 0 ? void 0 : _d.data);
    }
}));
export const { logout } = authSlice.actions;
export const authReducer = authSlice.reducer;
export default authSlice;
